import { TService, useAddService } from '@/models/services';
import { notifications } from '@mantine/notifications';
import { useLocation } from 'wouter';
import ServiceEditor from './ServiceEditor';
import { Box } from '@mantine/core';

export default function ServiceAddPage() {
  const [_, nav] = useLocation();
  const { mutate: addService } = useAddService();

  return (
    <Box maw={'400px'}>
      <ServiceEditor
        title="Add new LegalBison service"
        onSave={(pendingService) => {
          addService(pendingService as Omit<TService, 'id'>, {
            onSuccess: (service: TService) => {
              nav(`/${service.id}`);
              notifications.show({
                title: `Service added`,
                message: `Service "${pendingService.name}" was addedd successfully.`,
                color: 'green',
                position: 'top-right',
              });
            },
          });
        }}
      />
    </Box>
  );
}
